<template>
  <ModalDialog
    ref="dialog"
    title="Station Scan Options"
    icon="fa-scanner"
    :showFooter="true"
    :scrollable="false"
    :showSubmit="true"
    submitTitle="Select"
    :submitting="submitting"
    :submitDisabled="submitDisabled"
    @closed="onClosed"
    @submitted="onSubmitted">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />
    <FormGroup v-bind:form="form" :labelColumnSize="3" v-if="!loading && !loadingError">
      <ContentTitle>Inventory Bin Options</ContentTitle>

      <FormRow label="Default Panel Inventory Bin">
        <FormInventoryBinSelect
          v-model="productionStation.panelInventoryBinId"
          placeholder="Panel Inventory Bin"
          :accountLocationId="productionStation.accountLocationId"
          note="Inventory bin where scanned out panels will be placed"
          field="panelInventoryBinId"
        />
      </FormRow>

      <FormRow label="Default Offcut Inventory Bin" v-if="isCuttingStation">
        <FormInventoryBinSelect
          v-model="productionStation.offcutInventoryBinId"
          placeholder="Offcut Inventory Bin"
          :accountLocationId="productionStation.accountLocationId"
          note="Inventory bin where scanned out offcuts will be placed"
          field="offcutInventoryBinId"
        />
      </FormRow>
            
    </FormGroup>
    
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import FormInventoryBinSelect from '@/modules/inventory/components/formInventoryBinSelect'

import { ProductionStationTypes } from '@/store/types'

export default {
  name: 'StationScanOptionsDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
    FormInventoryBinSelect
  },
  props: {
    productionStationId: Number
  },
  data() {
    return {
      form: {},
      loading: false,
      loadingError: '',
      submitting: false,
      productionStation: {}
    }
  },
  created() {
  },
  mounted() {
    this.requestData()
  },
  computed: {
    isCuttingStation() {
      return this.productionStation.type == ProductionStationTypes.cutting || 
        this.productionStation.type == ProductionStationTypes.cuttingOptimisation ||
        this.productionStation.type == ProductionStationTypes.cuttingBreakout
    },
    submitDisabled() {
      return this.loading || this.loadingError != ''
    }
  },
  methods: {
    show() {

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      var updateData = {
        panelInventoryBinId: this.productionStation.panelInventoryBinId,
      }
      if(this.isCuttingStation)
        updateData.offcutInventoryBinId = this.productionStation.offcutInventoryBinId

      this.form = this.clearFormResponse()
      this.submitting = true
      this.$apiService.glassProductionStationService.updateStationScanOptions(this.productionStationId, updateData)
      .then(response => {
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.form = this.processFormResponse(err)
      })
      .finally(() => {
        this.submitting = false
      })
    },
    requestData() {
      this.loading = true

      this.$apiService.productionService.getProductionStation(this.productionStationId)
      .then(response => {
        this.productionStation = response.data
      })
      .catch(err => {
        console.error(err)
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>